import { render, staticRenderFns } from "./FinalizeAccount.vue?vue&type=template&id=8bd2724a&scoped=true&"
import script from "./FinalizeAccount.vue?vue&type=script&lang=ts&"
export * from "./FinalizeAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2724a",
  null
  
)

export default component.exports